// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1icxn","col":"styles_col__c68is","fulfillmentStatus":"styles_fulfillmentStatus__3Zs8R","emailCol":"styles_emailCol__3Ejih"};